<template>
  <RevInputFileUpload
    :id
    v-model="files"
    :accept="ACCEPTED_FILE_TYPES"
    :description="description ?? ''"
    :disabled
    :label-empty="labelEmpty ?? i18n(translations.selectFile)"
    :max-file-size="MAX_FILE_SIZE"
    :max-files="1"
    @errors="$emit('errors', $event)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputFileUpload } from '@ds/components/InputFileUpload'
import type { FileError } from '@ds/components/InputFileUpload/InputFileUpload.type'

import { ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from './InputFileUpload.constants'
import translations from './InputFileUpload.translations'

const i18n = useI18n()

defineProps<{
  id: string
  description?: string
  disabled?: boolean
  labelEmpty?: string
}>()

const model = defineModel<File>()

defineEmits<{
  errors: [errors: FileError[]]
}>()

const files = computed({
  get: () => (model.value ? [model.value] : []),
  set: (value: File[]) => {
    model.value = value[0]
  },
})
</script>
